/* __next_internal_client_entry_do_not_use__ RenderInsiderRoutesForVisitor auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { LoggedOutInsiderMarketingPage } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/LoggedOutInsiderMarketingPage";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { Route } from "@faire/web-api--source/Route";
import { props as insiderMarketingPageProps } from "@faire/web-api--source/routes/insider";
import { props as insiderTermsAndConditionsRouteProps } from "@faire/web-api--source/routes/insider/terms-and-conditions";
import insiderTermsOfService from "@faire/web-api--source/routes/tos-insider";
import React from "react";
import { Redirect } from "react-router-dom";
export var RenderInsiderRoutesForVisitor = function() {
    return /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, insiderMarketingPageProps), {
        children: /*#__PURE__*/ _jsx(InsiderRouter, {})
    }));
};
var InsiderRouter = function() {
    var hasAccessToLoggedOutInsiderMarketingPage = useInsiderFeatureEligibility().hasAccessToLoggedOutInsiderMarketingPage;
    return /*#__PURE__*/ _jsxs(Switch, {
        children: [
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, insiderMarketingPageProps), {
                exact: true,
                children: hasAccessToLoggedOutInsiderMarketingPage ? /*#__PURE__*/ _jsx(LoggedOutInsiderMarketingPage, {}) : /*#__PURE__*/ _jsx(Redirect, {
                    to: home({
                        signIn: "1",
                        redirectTo: getCurrentPath().toString()
                    })
                })
            })),
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, insiderTermsAndConditionsRouteProps), {
                children: /*#__PURE__*/ _jsx(Redirect, {
                    to: insiderTermsOfService()
                })
            }))
        ]
    });
};
